import React from 'react'
import { graphql } from 'gatsby'
import Header from '../components/header'
import Layout from '../components/layout'
import SEO from '../components/seo'
import Spacer from '../components/spacer'

export default function PrivacyPolicy({ data: { page }, location }) {
	const seo = page?.seo
	return (
		<Layout>
			<SEO title={seo?.title || 'Privacy Policy: SIERA Group’s Commitment to Your Privacy'} description={seo?.description} image={seo?.image?.url} pathname={location.pathname} />
			<Header />
			<Spacer />
			<h1 className='sr-only'>Privacy Policy: Protecting Your Information with Care</h1>
			<div className='h1  max-1400 ma p40'>Privacy Policy</div>
			<Spacer />
			<Spacer className='m-hide' />
			<Spacer className='m-hide' />
			<Spacer className='m-hide' />
			<div className='max-1400 ma p40'>
				<div className='privacy-policy-content max-900' dangerouslySetInnerHTML={{ __html: page.content }} />
				<Spacer />
			</div>
		</Layout>
	)
}

export const query = graphql`
	query PrivacyPolicy {
		page: datoCmsPrivacyPolicy {
			content
			seo {
				title
				description
				image {
					url
				}
			}
		}
	}
`
